import _sortBy from 'lodash.sortby';
import _uniqBy from 'lodash/uniqBy';

export default function getUniqueAndSortedChatMessages(messages: connect.ChatTranscriptItem[]) {
  return _sortBy(_uniqBy(messages, 'Id'), 'AbsoluteTime', 'desc');
}
